let bootstrapVersion = 4 | 5;

export function SetBootstrapVersion(version: 4 | 5) {
    bootstrapVersion = version;
}

export function GetBootstrapVersion() {
    return bootstrapVersion;
}

let bootstrapPrefix = 'bs-';

export function SetBootstrapPrefix(prefix: string) {
    bootstrapPrefix = prefix;
}

export function GetBootstrapPrefix() {
    return bootstrapPrefix;
}
